const apiPaths = {
    getPendingUserAccounts: '/api/pendinguseraccount',
    approvePendingUserAccount: '/api/pendinguseraccount/approve',
    deletePendingUserAccount: '/api/pendinguseraccount',
    getCurrentApplicationUser: '/api/application/currentuser',
    logout: '/api/application/logout',
    submitQuoteRequest: '/api/quoterequest',
    getQuoteRequestPage: '/api/quoterequest',
    getDismissedQuoteRequestPage: '/api/quoterequest/dismissed',
    dismissQuoteRequest: '/api/quoterequest/dismiss',
    createShipment: '/api/shipment',
    editShipment: '/api/shipment',
    getShipment: '/api/shipment',
    getActiveShipmentsWithLatestStatus: '/api/shipment/active',
    getCompletedShipmentsWithLatestStatus: '/api/shipment/completed',
    getShipmentUpdates: '/api/shipmentupdate',
    trackShipments: '/api/shipment/track',
    getStatusOptions: '/api/shipmentstatus',
    createShipmentUpdate: '/api/shipmentupdate',
    editShipmentUpdate: '/api/shipmentupdate',
    deleteShipmentUpdate: '/api/shipmentupdate',
    requestProofOfDelivery: '/api/proofofdelivery',
    getProofOfDeliveryForShipment: '/api/proofofdelivery'
};

export default apiPaths;